module.exports = __webpack_public_path__ + "static/media/game(11).839f19ba.PNG";